import { connect } from 'react-redux'
import moment from 'moment-timezone'
import { push } from 'react-router-redux'

import RescheduleRecurrenceConfirm from './RescheduleRecurrenceConfirm'
import { getRecurrences, getAliadas } from '@src/redux/modules/entities'
import {
  fetch as fetchRecurrence,
  update as updateRecurrence,
  isUpdating
} from '@src/redux/modules/recurrence'
import * as qs from 'utils/querystring'

function getBeforeRescheduleRecurrenceDetails (recurrence, aliadas) {
  const aliada = aliadas[recurrence.aliada]

  const details = {
    aliada,
    weekday: recurrence.weekday,
    hour: recurrence.hour,
    periodicity: recurrence.periodicity,
    estimatedHours: recurrence.estimatedHours
  }

  return details
}

function getAfterRescheduleRecurrenceDetails (recurrence, queryobject, aliadas) {
  const { estimatedHours, datetime } = queryobject

  const aliada = aliadas[recurrence.aliada]

  const getWeekday = date => moment(date).format('dddd').toLowerCase()
  const weekday = getWeekday(datetime)

  const getHour = date => moment(date).hour()
  const hour = getHour(datetime)

  const details = {
    aliada,
    weekday,
    hour,
    periodicity: recurrence.periodicity,
    estimatedHours
  }

  return details
}

const selector = (state, props) => {
  const { recurrenceId } = props.params

  const recurrences = getRecurrences(state)
  const recurrence = recurrences[recurrenceId]

  let beforeRescheduleRecurrenceDetails, afterRescheduleRecurrenceDetails
  if (recurrence) {
    const aliadas = getAliadas(state)
    const queryobject = qs.parse(props.location.search)

    beforeRescheduleRecurrenceDetails = getBeforeRescheduleRecurrenceDetails(recurrence, aliadas)
    afterRescheduleRecurrenceDetails = getAfterRescheduleRecurrenceDetails(recurrence, queryobject, aliadas)
  }

  const updatingRecurrence = isUpdating(state)

  return {
    recurrence,
    beforeRescheduleRecurrenceDetails,
    afterRescheduleRecurrenceDetails,
    updatingRecurrence
  }
}

const actions = {
  fetchRecurrence,
  updateRecurrence,
  push
}

export default connect(selector, actions)(RescheduleRecurrenceConfirm)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/RescheduleRecurrenceConfirm/RescheduleRecurrenceConfirmContainer.js